import { createAsyncThunk } from "@reduxjs/toolkit";
import { closeSnackbar, enqueueSnackbar, SnackbarKey } from "notistack";

import { getDashboardsHierarchyThunk } from "./getDashboardsHierarchyThunk";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const deleteDashboardHierarchyFolderThunkFixedCacheKey =
  "deleteDashboardFolderThunk-fixedCacheKey";

export const deleteDashboardFolderThunk = createAsyncThunk(
  "dashboard/deleteDashboardFolder",
  async (id: string, { dispatch }) => {
    const { deleteUsersMeOrganisationsCurrentDashboardFoldersByFolderId } =
      cloudChiprApi.endpoints;

    try {
      await dispatch(
        deleteUsersMeOrganisationsCurrentDashboardFoldersByFolderId.initiate(
          {
            folderId: id,
          },
          {
            fixedCacheKey: deleteDashboardHierarchyFolderThunkFixedCacheKey,
          },
        ),
      ).unwrap();
      dispatch(getDashboardsHierarchyThunk());

      const snackbarId: SnackbarKey = enqueueSnackbar(
        "Folder successfully deleted.",
        {
          variant: "snackbarAlert",
          AlertSnackBarProps: {
            severity: "success",
            onClose: () => closeSnackbar(snackbarId),
          },
        },
      );
    } catch (e) {
      // @ts-expect-error TODO: return to this after adding error type
      const errMessage = e?.data?.message || "Something went wrong";
      const snackbarId: SnackbarKey = enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: {
          severity: "error",
          onClose: () => closeSnackbar(snackbarId),
        },
      });
    }
  },
);
